import React from "react"
import styled from "styled-components"
import { navigate } from "gatsby"

import {
  BorderRadius,
  Color,
  Spacing,
  Typography,
} from "@persona-id/design-tokens"

const NavigationLeftCommunity = ({
  onNavLinkClick,
}: {
  onNavLinkClick?: () => void
}) => {
  return (
    <>
      <NavigationLeftLink
        onClick={() => {
          navigate("/community#podcasts")
          if (onNavLinkClick) onNavLinkClick()
        }}
      >
        Podcasts
      </NavigationLeftLink>
      <NavigationLeftLink
        onClick={() => {
          navigate("/community#events")
          if (onNavLinkClick) onNavLinkClick()
        }}
      >
        Events
      </NavigationLeftLink>
    </>
  )
}

const NavigationLeftLink = styled.div`
  ${Typography.TextMedium};
  display: flex;
  flex-direction: row;
  column-gap: ${Spacing[2]};
  align-items: center;
  padding: ${Spacing[1]};
  border-radius: ${BorderRadius.Sm};
  cursor: pointer;

  :hover {
    color: ${Color.CorePurple800};
    background-color: ${Color.CorePurple100};
  }
`

export default NavigationLeftCommunity
